// extracted by mini-css-extract-plugin
export default {"AvailableScreeningsCard":"AvailableScreeningsCard_AvailableScreeningsCard__viCv5","Label":"AvailableScreeningsCard_Label__dzUW-","Total":"AvailableScreeningsCard_Total__h7Uhs"};